import { defineBool } from '@spotify-internal/remote-config-properties';

export const FeatureFlagUsersBool = defineBool({
  name: 'frodor-feature-flag-users',
  description: 'Frodor feature flag users',
  default: false,
});
